import { useEffect, useRef } from "react";
import nextCookie from "next-cookies";
import Router from "next/router";
import Head from "next/head";

import { Line, Logo, Bottom, Space, Slides } from "../../styles/styles-marcas/home"
import InputMask from 'react-input-mask';
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import { ProductList } from "../../components/ProductList/styles";
import { Pagination } from "../../components/Pagination/styles";
import { productsApi } from "../../services/api";
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay'
const AutoplaySlider = withAutoplay(AwesomeSlider)
const Outlet = ({ products, pages, token }) => {


  return (
    <Layout>
      <Head>
        <title key="title">Goods Br | Home</title>
        <meta key="og-title" property="og:title" content="Login | Goods Br" />
      </Head>
        <Container>
          <Logo src="/lg_goods-home.png" alt="Logo Goods Br Home" style={{marginLeft: "25%", marginRight: "25%"}}/>
            <Line>
              <Bottom>
                <h2>O espaço conceito da Goods Br se materializa em 2000m² de muita sofisticação, design, gastronomia e arquitetura. Uma loja que demonstra o que Gramado pode ter de melhor em móveis e decoração.</h2>
              </Bottom>
            </Line>
            <Slides>
            <AutoplaySlider
            play={true}
            cancelOnInteraction={false}
            interval={4000}
            bullets={false}
            touch={true}
            >
              <div data-src="/home/loja-1.jpg" />
              <div data-src="/home/loja-2.jpg" />
              <div data-src="/home/loja-3.jpg" />
              <div data-src="/home/loja-4.jpg" />
              <div data-src="/home/loja-5.jpg" />
              <div data-src="/home/loja-6.jpg" />
              <div data-src="/home/loja-7.jpg" />
              <div data-src="/home/loja-8.jpg" />
              <div data-src="/home/loja-9.jpg" />
              <div data-src="/home/loja-10.jpg" />
              <div data-src="/home/loja-11.jpg" />
              <div data-src="/home/loja-12.jpg" />
              <div data-src="/home/loja-13.jpg" />
              <div data-src="/home/loja-14.jpg" />
              <div data-src="/home/loja-15.jpg" />
              <div data-src="/home/loja-16.jpg" />
              <div data-src="/home/loja-17.jpg" />
              <div data-src="/home/loja-21.jpg" />
            </AutoplaySlider>
            </Slides>
        </Container>
    </Layout>
  );
};

Outlet.getInitialProps = async ctx => {
  const { token } = nextCookie(ctx);
  const { page } = ctx.query;

  const { products, pages } = await productsApi.outlet({
    user_token: token,
    page
  });

  return {
    products,
    pages,
    token
  };
};

export default Outlet;
